import { useState } from 'react';

import { useShutdownTimeLang } from './useShutdownTimeLang';
import { SHUTDOWN_TIME_OPTION } from 'features/menu-page/domain';

import type { ChangeEvent } from 'react';
import type { ShutdownTimeOption } from 'features/menu-page/domain';

export function useShutdownTime(props: Props) {
  const { customDate, onChange, onAcceptCustomDate } = props;

  const [isCustomOpt, setIsCustomOpt] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const dateNow = new Date();
  const hasCustomDate = customDate.getTime() !== 0;
  const minDatePicker = dateNow.setDate(dateNow.getDate() + 1);
  const maxDatePicker = dateNow.setDate(dateNow.getDate() + 29);

  const lang = useShutdownTimeLang();

  const handleOpenDatePicker = () =>
    setOpenDatePicker(s => (isCustomOpt ? true : s));

  const handleCloseDatePicker = () => setOpenDatePicker(false);

  const handleAcceptCustomDate = (date: Date | null) => {
    if (date === null) return;
    const fixDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
    );
    onAcceptCustomDate(fixDate);
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const _opt = event.target.value as ShutdownTimeOption;
    if (_opt === SHUTDOWN_TIME_OPTION.CUSTOM) {
      setIsCustomOpt(true);
      setOpenDatePicker(true);
    } else {
      setIsCustomOpt(false);
      setOpenDatePicker(false);
    }
    onChange(_opt);
  };

  return {
    lang,
    isCustomOpt,
    openDatePicker,
    hasCustomDate,
    valueOption: SHUTDOWN_TIME_OPTION,
    deadline: {
      minDatePicker,
      maxDatePicker,
    },
    handleOpenDatePicker,
    handleCloseDatePicker,
    handleAcceptCustomDate,
    handleOnChange,
  };
}

interface Props {
  customDate: Date;
  onChange: (option: ShutdownTimeOption) => void;
  onAcceptCustomDate: (date: Date) => void;
}
